  document.addEventListener('DOMContentLoaded', () => {
  	const form = document.getElementById('BarrierForm');
  	if (!form) return;

  	const errorMessages = window.errorMessages;

  	const errorBox = (input) => document.getElementById(input.getAttribute('aria-errormessage'));

  	const errorMessage = input => {
  		const name = input.name.match(/\[([^\]]+)\]/)?.[1];
  		const rules = errorMessages[name] || {};
  		const validity = input.validity;
  		if (validity.valueMissing && rules.valueMissing) return rules.valueMissing;
  		if (validity.typeMismatch && rules.typeMismatch) return rules.typeMismatch;
  		if (validity.patternMismatch && rules.patternMismatch) return rules.patternMismatch;
  	};

  	const showError = (input) => {
  		const box = errorBox(input);
  		input.setAttribute('aria-invalid', 'true');
  		box.textContent = errorMessage(input);
  		box.hidden = false;
  	};

  	const clearError = (input) => {
  		const box = errorBox(input);
  		input.removeAttribute('aria-invalid');
  		box.hidden = true;
  		box.textContent = '';
  	};

  	const isFieldOK = (input) => {
  		return input.checkValidity();
  	};

  	form.addEventListener('input', (e) => {
  		const inputTarget = e.target;
  		if (inputTarget.matches('[aria-errormessage]') && isFieldOK(inputTarget)) clearError(inputTarget);
  	});

  	form.addEventListener(
  		'submit',
  		(e) => {
  			const inputs = [...form.querySelectorAll('[aria-errormessage]')];
  			let firstFieldIsBad = null;
  			let noErrors = true;
  			inputs.forEach((input) => {
  				if (isFieldOK(input)) {
  					clearError(input);
  				} else {
  					noErrors = false;
  					showError(input);
  					if (!firstFieldIsBad) firstFieldIsBad = input;
  				}
  			});
  			if (!noErrors) {
  				e.preventDefault();
  				e.stopImmediatePropagation();
  				firstFieldIsBad.focus();
  			}
  		},
  		true,
  	);
  });